import React, { useEffect, useState } from 'react';
import PageLayout from '@/components/Layout/PageLayout';
import { UserDetails } from '@/components/auth/UserDetails';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useUserSession } from '@/hooks/useUserSession';
import AccessDenied from '@/components/AccessDenied';

const AdminPage: React.FC = () => {


// useUserSeesion is not being called . Figure out and fix it
const { user, isLoaded ,jwtToken} = useUserSession();

  // if (!user || user.role !== 'admin') return <AccessDenied />;
console.log("jwtToken :: ", jwtToken,user)
  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">System Administration</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Welcome, {user?.first_name || 'Admin'}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="mb-4">This is the admin portal where you can manage the entire system.</p>
              <p>Your role: <strong>{user?.role}</strong></p>
              <p>Authorization level: <strong>{user?.auth_level || 'admin'}</strong></p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>System Controls</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="list-disc pl-5 space-y-2">
                <li>User management</li>
                <li>Role and permissions</li>
                <li>System configuration</li>
                <li>Audit logs</li>
                <li>Database maintenance</li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {/* <div className="mt-8">
          <UserDetails />
        </div> */}
      </div>
    </PageLayout>
  );
};

export default AdminPage;
